const mutations = {
  setCurrentOrderPicking(state, payload) {
    state.currentOrderPicking = payload
  },

  setCurrentProductPicking(state, payload) {

    state.currentProductPicking = payload

  }
}

export default mutations

